import { getRouteRecency } from "../stores/swapRouteHistoryStore";
/**
 * Pure route-sorting utilities shared by `useFormRoutes` and the flat
 * RoutePicker list. Kept out of the hook module so they don't widen the hook's
 * public surface and can be reused without importing the hook.
 */
export const extractTokenElementsAsSuggested = (routes) => routes.flatMap(route => (route.tokens || []).map(token => ({ type: 'suggested_token', route: { token, route } })));
export const sortSuggestedTokenElements = (direction, balances, routesHistory, swapRecency) => (a, b) => {
    if (direction === "from" && balances) {
        const a_balance = getNetworkTokenElementBalance(a, balances);
        const b_balance = getNetworkTokenElementBalance(b, balances);
        if (a_balance !== b_balance) {
            return b_balance - a_balance;
        }
    }
    if (swapRecency) {
        const a_recency = getRouteRecency(swapRecency, direction, a.route.route.name, a.route.token.symbol);
        const b_recency = getRouteRecency(swapRecency, direction, b.route.route.name, b.route.token.symbol);
        if (a_recency !== b_recency) {
            return b_recency - a_recency;
        }
    }
    if (routesHistory) {
        const a_used = getUsedCount(a, routesHistory, direction);
        const b_used = getUsedCount(b, routesHistory, direction);
        if (a_used !== b_used) {
            return b_used - a_used;
        }
    }
    const a_rank = getRank(a, direction);
    const b_rank = getRank(b, direction);
    return a_rank - b_rank;
};
/** Raw token amount held for a route/token, or 0 when unknown. */
export const getTokenElementBalanceAmount = (item, balances) => balances?.[item.route.route.name]?.balances?.find(b => b.token === item.route.token.symbol)?.amount || 0;
const getNetworkTokenElementBalance = (item, balances) => {
    return getTokenElementBalanceAmount(item, balances) * item.route.token.price_in_usd;
};
const getUsedCount = (item, history, direction) => {
    return direction === "from" ? history.sourceRoutes?.[item.route.route.name]?.[item.route.token.symbol] || 0 : history.destinationRoutes?.[item.route.route.name]?.[item.route.token.symbol] || 0;
};
const getRank = (item, direction) => {
    switch (direction) {
        case "from":
            return item.route.token.source_rank || 0;
        case "to":
            return item.route.token.destination_rank || 0;
    }
};
